import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleAll(event) {
    document.querySelectorAll(".order-checkbox").forEach(cb => {
      cb.checked = event.target.checked
    })
  }
}